<app-common-modal #childModalValidate [name]="'editName'" [title]=" " [twoButtonsDialogs]="true" [withFooter]="false">
  <h4 class="modal-title" modal-title translate>T_OFFER_DATA_MANAGEMENT_CHANGE_CATEGORY_NAME</h4>
  <app-spinner *ngIf="isLoading" [sizeClass]="'medium'"></app-spinner>
  <div *ngIf="!isLoading" modal-body>
    <div *ngFor="let kv of translationsByLanguages; trackBy: trackByLang" class="row g-0">
      <div class="content-container">
        <div class="input-edit-translation row g-0 align-items-center">

          <span class="col-2 label-text">
            {{ kv.getKey() }}
          </span>

          <div class="col-10">
            <input
              (input)="tranlationChange(kv.getKey(), $event)"
              [value]="kv.getValue()"
              class="edit-input"
              type="text">
          </div>

        </div>

      </div>
    </div>

    <!-- Buttons -->
    <div class="modal-edit-category-name-footer form-horizontal">
      <button (click)="hide()" class="btn btn-default-white-background" translate>T_BUTTON_CANCEL</button>
      <button (click)="sendConfirmation(); hide()" *ngIf="!isAddedCategory" [disabled]="hasEmptyField()"
              class="btn btn-default-white-background" translate>T_BUTTON_EDIT
      </button>
      <button (click)="sendConfirmation(); hide()" *ngIf="isAddedCategory" [disabled]="hasEmptyField()"
              class="btn btn-default-white-background" translate>T_BUTTON_ADD
      </button>
    </div>
  </div>
</app-common-modal>
